interface FeaturedPlaceProps {
  featured: {
    name: string;
    likes: number;
    location: string;
    distance: string;
    image: string;
  };
  styles: {
    containerPadding: string;
    itemPadding: string;
    imageSize: string;
    fontSize: string;
    iconSize: string;
    gap: string;
  };
}

export function FeaturedPlace({ featured, styles }: FeaturedPlaceProps) {
  return (
    <div
      className={`bg-white rounded-lg shadow-sm overflow-hidden ${styles.containerPadding}`}
    >
      <img
        src={featured.image}
        alt={featured.name}
        className={`w-full object-cover ${styles.imageSize}`}
      />
      <div className={styles.itemPadding}>
        <h3 className={`font-semibold ${styles.fontSize}`}>{featured.name}</h3>
        <p className="text-gray-600 text-sm">{featured.location}</p>
        <div className="flex items-center mt-2">
          <span className="text-yellow-500">★</span>
          <span className="ml-1 text-sm">{featured.likes} likes</span>
          <span className="ml-2 text-sm text-gray-500">
            {featured.distance}
          </span>
        </div>
      </div>
    </div>
  );
}
